(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6763],{

/***/ 2119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2820);
/* harmony import */ var _shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var BlockHeader = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
            className: (_shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-header__title__custom"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["title-line-fms"])
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["title-name-fms"]),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_shared_shared_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["title-line-fms"])
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockHeader);


/***/ }),

/***/ 4937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _products_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1351);
/* harmony import */ var _products_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_products_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9587);
/* harmony import */ var _atoms_Toast_useToast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4213);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3385);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9695);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1043);
/* harmony import */ var _store_general__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6298);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _store_wishlist__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4444);















var ProductCard = function(param) {
    var product = param.product, dbName = param.dbName, translationsData = param.translationsData, backOrderValue = param.backOrderValue, _selectedCurrItems = param.selectedCurrItems, selectedCurrCode = _selectedCurrItems.selectedCurrCode, selectedCurrRate = _selectedCurrItems.selectedCurrRate, selectedCurrSymbol = _selectedCurrItems.selectedCurrSymbol, selectedLocale = param.selectedLocale, showWishlist = param.showWishlist, showCart = param.showCart, priority = param.priority, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    var toast = (0,_atoms_Toast_useToast__WEBPACK_IMPORTED_MODULE_4__/* .useToast */ .p)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)(), routerPush = ref.push;
    var cartToken = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.cartToken;
    });
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.customer;
    });
    var wishlist = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.wishlist;
    });
    var isProductInWishList = wishlist === null || wishlist === void 0 ? void 0 : wishlist.find(function(item) {
        return item.id === product.id;
    });
    var signed = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function(state) {
        return state.customer.authenticated;
    });
    var _qty = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(product.qty, 1), tmp = _qty[0], productQuantity = tmp === void 0 ? 0 : tmp, tmp1 = product.type, productType = tmp1 === void 0 ? "" : tmp1, productId = product.id, tmp2 = product.flats, ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(tmp2 === void 0 ? [] : tmp2, 1), tmp3 = ref1[0], ref2 = tmp3 === void 0 ? {} : tmp3, _has_up_sell = ref2.has_up_sell, has_up_sell = _has_up_sell === void 0 ? 0 : _has_up_sell, _has_cross_sell = ref2.has_cross_sell, has_cross_sell = _has_cross_sell === void 0 ? 0 : _has_cross_sell, _url_key = ref2.url_key, url_key = _url_key === void 0 ? "" : _url_key, _min_qty = ref2.min_qty, min_qty = _min_qty === void 0 ? 0 : _min_qty, tmp4 = ref2.name, productName = tmp4 === void 0 ? "" : tmp4, tmp5 = ref2.short_description, productShortDesc = tmp5 === void 0 ? "" : tmp5, tmp6 = ref2.price, productPrice = tmp6 === void 0 ? "" : tmp6, tmp7 = ref2.special_price, productSpecialPrice = tmp7 === void 0 ? "" : tmp7, tmp8 = product.images, ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(tmp8 === void 0 ? [] : tmp8, 1), imagePath = ref3[0];
    var isProductInStock = productType === "downloadable" ? false : productQuantity > 0 || !!parseFloat(backOrderValue);
    var toastOpenHandle = {
        "true": {
            "true": function() {
                return toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "d-flex chek-fms",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .FailSvg */ .as, {}),
                        translationsData.ProductNotAvailable
                    ]
                }));
            },
            "false": function() {
                return toastOpenHandle["true"]["true"]();
            }
        },
        "false": {
            "true": function() {
                return toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "d-flex chek-fms",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .CheckToastSvg */ .xQ, {}),
                        translationsData.ToastAddToCart
                    ]
                }));
            },
            "false": function() {}
        }
    };
    var upCrossSellHandle = {
        "true": {
            "true": function() {
                dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_8__/* .setPopupName */ .Sq)("upsell"));
                dispatch((0,_store_cart__WEBPACK_IMPORTED_MODULE_6__/* .getUpOrCrossProd */ .xM)(productId, "up-sell", selectedLocale, selectedCurrCode, 1, {
                    exchange_rate: {
                        rate: selectedCurrRate
                    },
                    symbol: selectedCurrSymbol,
                    code: selectedCurrCode
                }));
                dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_8__/* .setTempData */ .LH)([
                    product
                ]));
            },
            "false": function() {
                return upCrossSellHandle["true"]["true"]();
            }
        },
        "false": {
            "true": function() {
                dispatch((0,_store_cart__WEBPACK_IMPORTED_MODULE_6__/* .getUpOrCrossProd */ .xM)(productId, "cross-sell", selectedLocale, selectedCurrCode, 1, {
                    exchange_rate: {
                        rate: selectedCurrRate
                    },
                    symbol: selectedCurrSymbol,
                    code: selectedCurrCode
                }));
                dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_8__/* .setCrossValid */ .TV)(true));
                dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_8__/* .setPopupName */ .Sq)("crossSell"));
                dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_8__/* .setTempData */ .LH)([
                    product
                ]));
            },
            "false": function() {}
        }
    };
    var addToast = function(error) {
        return toastOpenHandle["".concat(error)]["".concat(isProductInStock)]();
    };
    var openUpCrossProd = function() {
        return upCrossSellHandle["".concat(!!parseFloat(has_up_sell))]["".concat(!!parseFloat(has_cross_sell))]();
    };
    var handlePrice = {
        true: {
            true: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().prices),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().new_price),
                        children: [
                            selectedCurrSymbol,
                            " ",
                            productSpecialPrice
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().old_price),
                        children: [
                            selectedCurrSymbol,
                            " ",
                            productPrice
                        ]
                    })
                ]
            }),
            false: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().prices),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().new_price),
                        children: [
                            selectedCurrSymbol,
                            " ",
                            productSpecialPrice
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().old_price),
                        children: [
                            selectedCurrSymbol,
                            " ",
                            productPrice
                        ]
                    })
                ]
            })
        },
        false: {
            true: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().prices),
                children: [
                    selectedCurrSymbol,
                    " ",
                    productPrice
                ]
            }),
            false: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().prices),
                children: [
                    selectedCurrSymbol,
                    " ",
                    productPrice
                ]
            })
        }
    };
    var handleWishIconClick = function(e) {
        e.preventDefault();
        if (!signed) {
            toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .FailSvg */ .as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        } else {
            !!isProductInWishList ? dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_12__/* .wishlistRemoveItem */ .uv)(product.id)) : dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_12__/* .wishlistAddItem */ .c8)(product, selectedLocale));
            var toastChildren = {
                "true": {
                    svg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .FailSvg */ .as, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishListRemove
                },
                "false": {
                    svg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .CheckToastSvg */ .xQ, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishList
                }
            };
            toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    toastChildren["".concat(!!isProductInWishList)].svg,
                    toastChildren["".concat(!!isProductInWishList)].title
                ]
            }));
        }
    };
    var handleAddToCard = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(e) {
            var addCardData, addItemCallback;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        addCardData = [
                            product,
                            1,
                            cartToken,
                            customer,
                            selectedLocale,
                            selectedCurrCode,
                            null,
                            addToast,
                            undefined
                        ];
                        addItemCallback = function() {
                            return _store_cart__WEBPACK_IMPORTED_MODULE_6__/* .cartAddItem.apply */ .rg.apply(null, addCardData);
                        };
                        if (isProductInStock && min_qty <= 1) {
                            if (has_up_sell) {
                                openUpCrossProd();
                                return [
                                    2
                                ];
                            } else if (has_cross_sell) {
                                openUpCrossProd();
                                dispatch(addItemCallback());
                                return [
                                    2
                                ];
                            }
                            dispatch(addItemCallback());
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            routerPush("/".concat(url_key))
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function handleAddToCard(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var hasWishlist = {
        "true": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__buttons"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: handleWishIconClick,
                className: "btn-light btn-svg-icon btn-svg-icon--fake-svg ".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__wishlist"])),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["wishlist-icon-wrapper"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .HeartSvg */ .xO, {
                        className: isProductInWishList ? (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["inner-wishlist"]) : ""
                    })
                })
            })
        }),
        "false": null
    };
    var hasCart = {
        "true": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().img_btn_wrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: handleAddToCard,
                className: "btn btn-primary ".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__addToCart"]), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["hide-for-tablet"])),
                children: translationsData.AddToCartButtonTitle
            })
        }),
        "false": null
    };
    var hasCartForTablet = {
        "true": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            onClick: handleAddToCard,
            className: "btn btn-primary ".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__addToCart"]), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["hide-for-desktop"])),
            children: translationsData.AddToCartButtonTitle
        }),
        "false": null
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__image"])),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(url_key),
                    prefetch: priority,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-image__body"]), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-image__body-fms"])),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().item_overlay), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["hide-for-tablet"]))
                            }),
                            hasCart["".concat(showCart)],
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default().img_wrapper),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName).concat(imagePath)),
                                    alt: "product card image",
                                    loading: loading,
                                    width: "280",
                                    height: "280"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__info"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__name"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/".concat(url_key),
                            prefetch: priority,
                            children: productName
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card-description"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: productShortDesc
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__actions"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__availability-mobile"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["product-card__availability"]),
                                children: [
                                    translationsData.ProductAvailable,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-success",
                                        children: translationsData.ProductInStock
                                    })
                                ]
                            }),
                            handlePrice["".concat(!!productSpecialPrice)]["".concat(selectedCurrCode === "AMD")],
                            hasWishlist["".concat(showWishlist)]
                        ]
                    }),
                    hasCartForTablet["".concat(showCart)]
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ }),

/***/ 9998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BuilderDataRender; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/builder/builder.module.scss
var builder_module = __webpack_require__(426);
var builder_module_default = /*#__PURE__*/__webpack_require__.n(builder_module);
;// CONCATENATED MODULE: ./components/builder/Heading/index.tsx


var Heading = function(param) {
    var _item = param.item, tag = _item.tag, _headingText = _item.headingText, headingText = _headingText === void 0 ? "" : _headingText, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: styles,
            dangerouslySetInnerHTML: {
                __html: "<".concat(tag, ">").concat(headingText, "</").concat(tag, ">")
            }
        })
    });
};
/* harmony default export */ var builder_Heading = (Heading);

;// CONCATENATED MODULE: ./components/builder/HyperLink/index.tsx


var HyperLink = function(param) {
    var _item = param.item, hyperLink = _item.hyperLink, hyperLinkName = _item.hyperLinkName, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: hyperLink,
            target: "_blank",
            style: styles,
            rel: "noreferrer",
            children: hyperLinkName
        })
    });
};
/* harmony default export */ var builder_HyperLink = (HyperLink);

;// CONCATENATED MODULE: ./components/builder/Editor/index.tsx

var Editor = function(param) {
    var _item = param.item, textEditorValue = _item.textEditorValue, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: styles,
            dangerouslySetInnerHTML: {
                __html: textEditorValue
            }
        })
    });
};
/* harmony default export */ var builder_Editor = (Editor);

;// CONCATENATED MODULE: ./components/builder/Accordion/AccordionLIst.tsx



var AccordionLIst = function(param) {
    var _faq = param.faq, title = _faq.title, description = _faq.description, _styles = param.styles, backgroundColor = _styles.backgroundColor, color = _styles.color;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var itemRef = (0,react.useRef)(null);
    var bodyRef = (0,react.useRef)(null);
    var handleAccordion = function() {
        if (bodyRef.current) {
            if (bodyRef.current.style.maxHeight) {
                bodyRef.current.style.maxHeight = null;
                bodyRef.current.style.paddingBottom = 0;
            } else {
                bodyRef.current.style.maxHeight = bodyRef.current.scrollHeight + 20 + "px";
                bodyRef.current.style.backgroundColor = "transparent";
                bodyRef.current.style.paddingBottom = "20px";
            }
        }
    };
    (0,react.useEffect)(function() {
        var handleEvent = function(e) {
            if (itemRef && itemRef.current && !itemRef.current.contains(e.target)) {
                setTimeout(function() {
                    setOpen(false);
                    if (bodyRef.current.style.maxHeight) {
                        handleAccordion();
                    }
                }, 100);
            }
        };
        document.addEventListener("mousedown", handleEvent);
        return function() {
            return document.removeEventListener("mousedown", handleEvent);
        };
    }, []);
    var handleOpen = function() {
        setOpen(!open);
        handleAccordion();
    };
    var plusClasses = {
        "true": "".concat((builder_module_default()).plus, " ").concat((builder_module_default()).open),
        "false": "".concat((builder_module_default()).plus)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (builder_module_default()).faq_component_item,
        ref: itemRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (builder_module_default()).faq_title_wrapper,
                style: {
                    backgroundColor: backgroundColor
                },
                onClick: handleOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (builder_module_default()).faq_title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: plusClasses["".concat(open)]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_module_default()).faq_body,
                ref: bodyRef,
                style: {
                    color: color
                },
                dangerouslySetInnerHTML: {
                    __html: description
                }
            })
        ]
    });
};
/* harmony default export */ var Accordion_AccordionLIst = (AccordionLIst);

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/schemaorg/index.tsx
var schemaorg = __webpack_require__(1257);
;// CONCATENATED MODULE: ./components/builder/Accordion/index.tsx








var Accordion = function(param) {
    var _item = param.item, id = _item.id, accordionFaq = _item.accordionFaq, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles;
    var schema = (0,schemaorg/* schemaString */.WN)(accordionFaq);
    var faqsRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "".concat(id),
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_module_default()).faq_component,
                "data-aos": dataAos,
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parentStyles), {
                    margin: styles.margin,
                    padding: styles.padding
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (builder_module_default()).faqs,
                        ref: faqsRef,
                        children: accordionFaq.map(function(faq) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_AccordionLIst, {
                                styles: styles,
                                faq: faq
                            }, faq.id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var builder_Accordion = (Accordion);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./store/general/index.ts + 3 modules
var general = __webpack_require__(6298);
;// CONCATENATED MODULE: ./hooks/useInView.tsx

function useIsInView(ref) {
    var _$ref = (0,react.useState)(false), isInView = _$ref[0], setIsInView = _$ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var _$ref;
            var rect = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.getBoundingClientRect();
            if (rect) {
                var elementTop = rect.top + window.scrollY; // Add scrollY for accurate position
                var elementBottom = elementTop + rect.height;
                var viewportTop = window.scrollY;
                var viewportBottom = viewportTop + window.innerHeight;
                setIsInView(elementTop >= viewportTop && elementBottom <= viewportBottom);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        ref
    ]);
    return isInView || false;
}

;// CONCATENATED MODULE: ./components/builder/ImageUpload/index.tsx








var ImageUpload = function(param) {
    var _item = param.item, switchValue = _item.switchValue, _linkValue = _item.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, linkTarget = _item.linkTarget, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, imageSwitchStyles = ref.styles, imageStyles = _item.imageStyles, defaultImage = _item.defaultImage, dbName = param.dbName;
    var ref2 = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleModalOpen = function() {
        if (switchValue) {
            dispatch((0,general/* setPopupName */.Sq)("zoom_in"));
            dispatch((0,general/* setPopup */.ZA)(true));
            dispatch((0,general/* setBuilderUrl */.dN)(defaultImage));
        }
    };
    var imagePropHandler = {
        "true": {},
        "false": {
            onClick: handleModalOpen
        }
    };
    var LinkLayoutToggle = function(param) {
        var children = param.children;
        var jsxWithLayout = {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkValue,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: linkTarget,
                    children: children
                })
            }),
            "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: children
            })
        };
        return jsxWithLayout["".concat(!!linkValue)];
    };
    var inView = !!dataAos ? useIsInView(ref2) : true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        className: !inView ? "dataAosRef" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkLayoutToggle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,_object_spread/* default */.Z)({}, imageSwitchStyles, imageStyles),
                ref: ref2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
                    src: defaultImage,
                    alt: "builder image",
                    layout: "fill",
                    loading: "lazy",
                    style: (0,_object_spread/* default */.Z)({}, imageSwitchStyles, imageStyles)
                }, imagePropHandler["".concat(!!linkValue)]))
            })
        })
    });
};
/* harmony default export */ var builder_ImageUpload = (ImageUpload);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./components/builder/SliderComponent/builder_slider.module.scss
var builder_slider_module = __webpack_require__(7478);
var builder_slider_module_default = /*#__PURE__*/__webpack_require__.n(builder_slider_module);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(9587);
;// CONCATENATED MODULE: ./components/builder/SliderComponent/index.tsx








var SliderComponent = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (builder_slider_module_default()).slider,
        "data-aos": item.slider.settings.animation,
        style: {
            height: item.slider.settings.height
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.slider.settings), {
            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* SliderNextArrow */.QY, {}),
            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* SliderPrevArrow */.DY, {}),
            children: item.slider.slides.map(function(slide) {
                var _content = slide.content, _title = _content.title, title = _title === void 0 ? "" : _title, _description = _content.description, description = _description === void 0 ? "" : _description, _buttonText = _content.buttonText, buttonText = _buttonText === void 0 ? "" : _buttonText, _link = _content.link, link = _link === void 0 ? "" : _link, showDescription = _content.showDescription, buttonLinkTarget = _content.buttonLinkTarget, showButtonText = _content.showButtonText;
                var _style = slide.style, contentAnimation = _style.contentAnimation, contentColor = _style.contentColor, horizontal = _style.horizontal, vertical = _style.vertical, textAlign = _style.textAlign;
                var ShowDesc = function() {
                    var descHandler = {
                        "Desc": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_slider_module_default()).content_description,
                            children: description
                        }),
                        "Empty": null
                    };
                    return descHandler[showDescription];
                };
                var ShowBtn = function() {
                    var btnHandler = {
                        "BtnText": /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: link,
                            target: buttonLinkTarget,
                            className: (builder_slider_module_default()).content_button,
                            children: buttonText
                        }),
                        "Empty": null
                    };
                    return btnHandler[showButtonText];
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (builder_slider_module_default()).slide_wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "slider image",
                            "aria-hidden": "true",
                            width: 500,
                            height: 500,
                            src: slide.slider_path
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_slider_module_default()).content_wrapper,
                            style: {
                                justifyContent: horizontal,
                                alignItems: vertical
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (builder_slider_module_default()).content,
                                "data-aos": contentAnimation,
                                style: {
                                    color: contentColor,
                                    alignItems: textAlign
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (builder_slider_module_default()).content_title,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowDesc, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowBtn, {})
                                ]
                            })
                        })
                    ]
                });
            })
        }))
    });
};
/* harmony default export */ var builder_SliderComponent = (SliderComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./store/cart/index.ts + 3 modules
var cart = __webpack_require__(9695);
// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(5564);
;// CONCATENATED MODULE: ./components/builder/Button/index.tsx












var Button = function(param) {
    var _item = param.item, buttonType = _item.buttonType, _buttonValue = _item.buttonValue, buttonValue = _buttonValue === void 0 ? "" : _buttonValue, linkValue = _item.linkValue, targeting = _item.targeting, productForBuyNow = _item.productForBuyNow, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, _selectedLocale = param.selectedLocale, selectedLocale = _selectedLocale === void 0 ? "" : _selectedLocale, _backOrderValue = param.backOrderValue, backOrderValue = _backOrderValue === void 0 ? "" : _backOrderValue, tmp3 = param.currencies, ref2 = (0,_sliced_to_array/* default */.Z)(tmp3 === void 0 ? [] : tmp3, 1), tmp4 = ref2[0], ref3 = tmp4 === void 0 ? {} : tmp4, tmp5 = ref3.code, selectedCurrCode = tmp5 === void 0 ? "" : tmp5, tmp6 = ref3.symbol, selectedCurrSymbol = tmp6 === void 0 ? "" : tmp6, tmp7 = ref3.exchange_rate, ref4 = tmp7 === void 0 ? {} : tmp7, tmp8 = ref4.rate, selectedCurrRate = tmp8 === void 0 ? "1" : tmp8;
    var ref5 = productForBuyNow || {}, tmp9 = ref5.qty, ref6 = (0,_sliced_to_array/* default */.Z)(tmp9 === void 0 ? [] : tmp9, 1), tmp10 = ref6[0], productQuantity = tmp10 === void 0 ? 0 : tmp10, tmp11 = ref5.id, productId = tmp11 === void 0 ? 0 : tmp11, tmp12 = ref5.flats, ref7 = (0,_sliced_to_array/* default */.Z)(tmp12 === void 0 ? [] : tmp12, 1), tmp13 = ref7[0], ref8 = tmp13 === void 0 ? {} : tmp13, _min_qty = ref8.min_qty, min_qty = _min_qty === void 0 ? 1 : _min_qty, _has_up_sell = ref8.has_up_sell, has_up_sell = _has_up_sell === void 0 ? 0 : _has_up_sell, _has_cross_sell = ref8.has_cross_sell, has_cross_sell = _has_cross_sell === void 0 ? 0 : _has_cross_sell, _url_key = ref8.url_key, url_key = _url_key === void 0 ? "" : _url_key, tmp14 = ref8.name, productName = tmp14 === void 0 ? "" : tmp14, tmp15 = ref8.short_description, productShortDesc = tmp15 === void 0 ? "" : tmp15, tmp16 = ref8.price, productPrice = tmp16 === void 0 ? "" : tmp16, tmp17 = ref8.special_price, productSpecialPrice = tmp17 === void 0 ? "" : tmp17, tmp18 = ref5.images, ref9 = (0,_sliced_to_array/* default */.Z)(tmp18 === void 0 ? [] : tmp18, 1), imagePath = ref9[0], tmp19 = ref5.type, productType = tmp19 === void 0 ? "" : tmp19;
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var tagEntry = "<p>".concat(buttonValue, "</p>");
    styles = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
        border: "none",
        "font-size": "16px",
        cursor: "pointer"
    });
    var ref10 = styles || {}, linkColor = ref10.color, fontSizeLink = ref10["font-size"], fontFamilyLink = ref10.fontFamily;
    var linkStyles = {
        color: linkColor,
        fontSize: fontSizeLink,
        fontFamily: fontFamilyLink
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref11 = (0,next_router.useRouter)(), routerPush = ref11.push;
    var isProductInStock = productQuantity > 0 || !!parseFloat(backOrderValue);
    var cartDataObj = {
        product: productForBuyNow,
        quantity: 1,
        cartToken: cartToken,
        customer: customer,
        selectedLocale: selectedLocale,
        selectedCurrCode: selectedCurrCode,
        optionsObject: null,
        addToast: function() {}
    };
    var upCrossSellHandle = {
        "true": {
            "true": function() {
                dispatch((0,general/* setPopupName */.Sq)("upsell"));
                dispatch((0,cart/* getUpOrCrossProd */.xM)(productId, "up-sell", selectedLocale, selectedCurrCode, 1, {
                    exchange_rate: {
                        rate: selectedCurrRate
                    },
                    symbol: selectedCurrSymbol,
                    code: selectedCurrCode
                }));
                dispatch((0,general/* setTempData */.LH)([
                    productForBuyNow
                ]));
            },
            "false": function() {
                return upCrossSellHandle["true"]["true"]();
            }
        },
        "false": {
            "true": function() {
                dispatch((0,cart/* getUpOrCrossProd */.xM)(productId, "cross-sell", selectedLocale, selectedCurrCode, 1, {
                    exchange_rate: {
                        rate: selectedCurrRate
                    },
                    symbol: selectedCurrSymbol,
                    code: selectedCurrCode
                }));
                dispatch((0,general/* setCrossValid */.TV)(true));
                dispatch((0,general/* setPopupName */.Sq)("crossSell"));
                dispatch((0,general/* setTempData */.LH)([
                    productForBuyNow
                ]));
            },
            "false": function() {}
        }
    };
    var openUpCrossProd = function() {
        return upCrossSellHandle["".concat(!!parseFloat(has_up_sell))]["".concat(!!parseFloat(has_cross_sell))]();
    };
    var handleBuyNow = function(e) {
        e.preventDefault();
        shop/* default.getEmptyCart */.Z.getEmptyCart(customer.authenticated, customer.token, cartToken.cartToken).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!res.message) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,_async_to_generator/* default */.Z)(function() {
                                    var addItemCallback;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                addItemCallback = function() {
                                                    return cart/* cartAddItem.apply */.rg.apply(null, Object.values(cartDataObj));
                                                };
                                                if (!(isProductInStock && min_qty <= 1 && productType !== "downloadable")) return [
                                                    3,
                                                    5
                                                ];
                                                if (!has_up_sell) return [
                                                    3,
                                                    1
                                                ];
                                                openUpCrossProd();
                                                return [
                                                    2
                                                ];
                                            case 1:
                                                if (!has_cross_sell) return [
                                                    3,
                                                    3
                                                ];
                                                openUpCrossProd();
                                                dispatch(addItemCallback());
                                                return [
                                                    4,
                                                    routerPush("/checkout")
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                            case 3:
                                                dispatch(addItemCallback());
                                                return [
                                                    4,
                                                    routerPush("/checkout")
                                                ];
                                            case 4:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                            case 5:
                                                return [
                                                    4,
                                                    routerPush("/".concat(url_key))
                                                ];
                                            case 6:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                })()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var handleButtonType = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            style: styles,
            onClick: handleBuyNow,
            children: buttonValue
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            style: styles,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                style: linkStyles,
                href: linkValue,
                rel: "noreferrer",
                target: targeting,
                children: buttonValue
            })
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        children: handleButtonType["".concat(buttonType === "Buy now")]
    });
};
/* harmony default export */ var builder_Button = (Button);

;// CONCATENATED MODULE: ./hooks/useIsInViewPort.tsx


function useIsInViewport(ref) {
    var _$ref = (0,react.useState)(false), isIntersecting = _$ref[0], setIsIntersecting = _$ref[1];
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            return setIsIntersecting(entry.isIntersecting);
        });
        observer.observe(ref.current);
        return function() {
            observer.disconnect();
        };
    }, [
        ref
    ]);
    return isIntersecting;
}

;// CONCATENATED MODULE: ./components/builder/Video/index.tsx



var Video = function(props) {
    var _item = props.item, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, videoLink = _item.videoLink;
    var ref2 = (0,react.useState)(""), link = ref2[0], setLink = ref2[1];
    var viewRef = (0,react.useRef)(null);
    var isInViewport = useIsInViewport(viewRef);
    var ref3 = (0,react.useState)(false), needLoad = ref3[0], setNeedLoad = ref3[1];
    (0,react.useEffect)(function() {
        setLink(videoLink);
    }, []);
    (0,react.useEffect)(function() {
        if (isInViewport) {
            setNeedLoad(true);
        }
    }, [
        isInViewport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        ref: viewRef,
        children: needLoad && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: link,
            allow: "autoplay",
            width: "100%",
            height: (styles === null || styles === void 0 ? void 0 : styles.height) || "200px",
            style: {
                border: "none"
            }
        })
    });
};
/* harmony default export */ var builder_Video = (Video);

// EXTERNAL MODULE: ./components/posts/posts.module.scss
var posts_module = __webpack_require__(406);
var posts_module_default = /*#__PURE__*/__webpack_require__.n(posts_module);
// EXTERNAL MODULE: ./components/posts/PostCard.tsx
var PostCard = __webpack_require__(3519);
;// CONCATENATED MODULE: ./components/builder/PostsComponent/index.tsx




var PostsComponent = function(param) {
    var _item = param.item, tmp = _item.postComponentInfo, renderedPosts = tmp === void 0 ? [] : tmp, tmp1 = _item.convertedSettings, ref = tmp1 === void 0 ? {} : tmp1, tmp2 = ref.animationAos, ref1 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref1["data-aos"], dataAos = tmp3 === void 0 ? null : tmp3, translationsData = param.translationsData;
    var postsList = renderedPosts === null || renderedPosts === void 0 ? void 0 : renderedPosts.map(function(post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (posts_module_default()).post_list_item,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                post: post,
                category: post.default_category,
                translationsData: translationsData
            })
        }, post.id);
    });
    var viewPosts = {
        true: postsList,
        false: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (posts_module_default()).posts_list,
        "data-aos": dataAos,
        children: viewPosts["".concat(!!(postsList === null || postsList === void 0 ? void 0 : postsList.length))]
    });
};
/* harmony default export */ var builder_PostsComponent = (PostsComponent);

// EXTERNAL MODULE: ./components/builder/FormBuilderComponent/forms.module.scss
var forms_module = __webpack_require__(3811);
var forms_module_default = /*#__PURE__*/__webpack_require__.n(forms_module);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Heading.tsx



var Heading_Heading = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _subtype = _element.subtype, subtype = _subtype === void 0 ? "" : _subtype, _className = _element.className, className = _className === void 0 ? "" : _className, _label = _element.label, label = _label === void 0 ? "" : _label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className, " ").concat((forms_module_default())["heading_".concat(subtype)]),
        children: label
    });
};
/* harmony default export */ var FormAtoms_Heading = (Heading_Heading);

// EXTERNAL MODULE: ./store/formbuilder/index.ts + 3 modules
var formbuilder = __webpack_require__(1428);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/ErrorMessages.tsx


var ErrorMessages = function(param) {
    var _errors = param.errors, errors = _errors === void 0 ? [] : _errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: errors.map(function(error) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert-danger",
                children: error
            }, error);
        })
    });
};
/* harmony default export */ var FormAtoms_ErrorMessages = (ErrorMessages);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Input.tsx






var Input = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, _subtype = _element.subtype, subtype = _subtype === void 0 ? "" : _subtype, maxlength = _element.maxlength;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var inputRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (!reduxValue && inputRef && inputRef.current) {
            inputRef.current.value = "";
        }
    }, [
        reduxValue
    ]);
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                ref: inputRef,
                name: name,
                type: subtype,
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                maxLength: maxlength,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Input = (Input);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/InputNumber.tsx






var InputNumber = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, maxlength = _element.maxlength, min = _element.min, max = _element.max, step = _element.step;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input_number,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: "number",
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                maxLength: maxlength,
                min: min,
                max: max,
                step: step,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_InputNumber = (InputNumber);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/InputDate.tsx






var InputDate = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, _dateFormat = _element.dateFormat, dateFormat = _dateFormat === void 0 ? "" : _dateFormat, _startDate = _element.startDate, startDate = _startDate === void 0 ? "" : _startDate, _endDate = _element.endDate, endDate = _endDate === void 0 ? "" : _endDate;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input_date,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: "date",
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                // dateFormat={dateFormat}
                min: startDate,
                max: endDate,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_InputDate = (InputDate);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/InputFile.tsx






var InputFile = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _allowedFileExtension = _element.allowedFileExtension, allowedFileExtension = _allowedFileExtension === void 0 ? "" : _allowedFileExtension, _allowedFileSize = _element.allowedFileSize, allowedFileSize = _allowedFileSize === void 0 ? "" : _allowedFileSize, _multiple = _element.multiple, multiple = _multiple === void 0 ? false : _multiple;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var inputRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (!reduxValue && inputRef && inputRef.current) {
            inputRef.current.value = "";
        }
    }, [
        reduxValue
    ]);
    var handleChangeValue = function(event) {
        if (event.target.files && event.target.files[0]) {
            var file = event.target.files[0];
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener("load", function() {
                dispatch((0,formbuilder/* setFormElementValue */.yd)({
                    id: formId,
                    index: index,
                    fieldsForChange: {
                        value: file
                    }
                }));
            });
        }
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text_wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (forms_module_default()).info_text,
                        children: description
                    })
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                ref: inputRef,
                name: name,
                type: "file",
                className: handleClasses["".concat(!!errors[name])],
                accept: allowedFileExtension,
                size: +allowedFileSize,
                multiple: multiple,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_InputFile = (InputFile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./atoms/Toast/useToast.ts
var useToast = __webpack_require__(4213);
// EXTERNAL MODULE: ./node_modules/next-recaptcha-v3/lib/index.js + 5 modules
var next_recaptcha_v3_lib = __webpack_require__(9498);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Button.tsx














var Button_Button = function(param) {
    var formId = param.formId, formCode = param.formCode, index = param.index, element = param.element, formData = param.formData, recaptchaActive = param.recaptchaActive;
    var _className = element.className, className = _className === void 0 ? "" : _className, _label = element.label, label = _label === void 0 ? "" : _label, _name = element.name, name = _name === void 0 ? "" : _name, _style = element.style, style = _style === void 0 ? "" : _style, _subtype = element.subtype, subtype = _subtype === void 0 ? "button" : _subtype, _value = element.value, value = _value === void 0 ? "" : _value;
    var data = (0,es/* useSelector */.v9)(function(state) {
        return (state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        }) || {
            formData: []
        }).formData;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var toast = (0,useToast/* useToast */.p)();
    var router = (0,next_router.useRouter)();
    var executeRecaptcha = (0,next_recaptcha_v3_lib/* useReCaptcha */.CL)().executeRecaptcha;
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _loop, handleElementValue, newData, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, el, _tmp, err, key;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function(key) {
                            if (Array.isArray(newData[key])) {
                                newData[key].map(function(el, index) {
                                    formData.append(key + "[" + index + "]", el);
                                });
                            } else {
                                formData.append(key, newData[key]);
                            }
                        };
                        handleElementValue = function(element) {
                            var _label = element.label, label = _label === void 0 ? "" : _label, _value = element.value, value = _value === void 0 ? "" : _value, _name = element.name, name = _name === void 0 ? "" : _name, _values = element.values, values = _values === void 0 ? [] : _values, _multiple = element.multiple, multiple = _multiple === void 0 ? false : _multiple;
                            return {
                                "header": {
                                },
                                "text": (0,_define_property/* default */.Z)({}, name, value),
                                "number": (0,_define_property/* default */.Z)({}, name, value),
                                "date": (0,_define_property/* default */.Z)({}, name, value),
                                "file": (0,_define_property/* default */.Z)({}, name, value),
                                "button": {},
                                "checkbox-group": (0,_define_property/* default */.Z)({}, name, values.filter(function(el) {
                                    return el.selected;
                                }).map(function(el) {
                                    return el.value;
                                })),
                                "radio-group": (0,_define_property/* default */.Z)({}, name, (values.find(function(el) {
                                    return el.selected;
                                }) || {
                                    value: ""
                                }).value),
                                "textarea": (0,_define_property/* default */.Z)({}, name, value),
                                "select": (0,_define_property/* default */.Z)({}, name, values.filter(function(el) {
                                    return el.selected;
                                }).map(function(el) {
                                    return el.value;
                                }))
                            };
                        };
                        newData = {};
                        formData = new FormData();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = data[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        el = _step.value;
                        _tmp = [
                            {},
                            newData,
                            handleElementValue(el)[el.type]
                        ];
                        return [
                            4,
                            (0,_async_to_generator/* default */.Z)(function() {
                                var token;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(String(recaptchaActive) === "1")) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                executeRecaptcha("form_submit")
                                            ];
                                        case 1:
                                            token = _state.sent();
                                            return [
                                                2,
                                                {
                                                    re_token: token
                                                }
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                {}
                                            ];
                                    }
                                });
                            })()
                        ];
                    case 3:
                        newData = _object_spread/* default.apply */.Z.apply(void 0, _tmp.concat(_state.sent()));
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        for(var key in newData)_loop(key);
                        shop/* default.submitFormBuilder */.Z.submitFormBuilder(formData, formCode).then(function(res) {
                            if (res.errors) {
                                dispatch((0,formbuilder/* setFormErrors */.FB)(res.errors));
                                toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "d-flex chek-fms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                                        res.message
                                    ]
                                }));
                            } else {
                                if (res.type === "show_message") {
                                    toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "d-flex chek-fms",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                                            res.data
                                        ]
                                    }));
                                } else {
                                    router.push(res.data);
                                }
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReset = function() {
        dispatch((0,formbuilder/* addAndResetForm */.Cf)({
            id: formId,
            formData: formData
        }));
    };
    var handleOnClickByType = {
        "submit": handleSubmit,
        "reset": handleReset,
        "button": function() {}
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((forms_module_default()).form_button, " ").concat(className),
        // type={subtype}
        onClick: handleOnClickByType[subtype],
        children: label
    });
};
/* harmony default export */ var FormAtoms_Button = (Button_Button);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Checkbox.tsx









var Checkbox = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _className = _element.className, className = _className === void 0 ? "" : _className, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _inline = _element.inline, inline = _inline === void 0 ? false : _inline, _label = _element.label, label = _label === void 0 ? "" : _label, _name = _element.name, name = _name === void 0 ? "" : _name, _other = _element.other, other = _other === void 0 ? false : _other, _required = _element.required, required = _required === void 0 ? false : _required, _toggle = _element.toggle, toggle = _toggle === void 0 ? false : _toggle, _values = _element.values, values = _values === void 0 ? [
        {
            label: "",
            selected: false,
            value: ""
        }
    ] : _values;
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        var newValues = reduxValues.map(function(el) {
            if (el.value === e.target.value) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                    selected: !el.selected
                });
            }
            return el;
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: newValues
            }
        }));
    };
    var toggleCheckbox = function(label, selected, value) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).option,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).toggle_border,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((forms_module_default()).toggle, " ").concat(selected ? (forms_module_default()).checked : " "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: name + " " + value,
                                type: "checkbox",
                                name: name,
                                value: value,
                                checked: selected,
                                onChange: handleChangeValue
                            }, name + " " + value),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (forms_module_default()).check,
                                children: " "
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: name + " " + value,
                    children: label
                })
            ]
        }, name + " " + value);
    };
    var hasOtherOption = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_OtherInput, {
            formId: formId,
            index: index,
            name: name,
            type: "checkbox"
        }),
        false: null
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    var handleOptionsStyle = {
        true: {
            flexDirection: "row"
        },
        false: {
            flexDirection: "column"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((forms_module_default()).form_checkbox, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).options,
                style: handleOptionsStyle["".concat(inline)],
                children: [
                    reduxValues.map(function(param) {
                        var _label = param.label, label = _label === void 0 ? "" : _label, _selected = param.selected, selected = _selected === void 0 ? false : _selected, _value = param.value, value = _value === void 0 ? "" : _value;
                        var handleOther = {
                            true: {
                                true: toggleCheckbox(label, selected, value),
                                false: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (forms_module_default()).option,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: name + " " + value,
                                            type: "checkbox",
                                            name: name,
                                            value: value,
                                            checked: selected,
                                            onChange: handleChangeValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: name + " " + value,
                                            children: label
                                        })
                                    ]
                                }, name + " " + value)
                            },
                            false: {
                                true: null,
                                false: null
                            }
                        };
                        return handleOther["".concat(label !== "other")]["".concat(toggle)];
                    }),
                    hasOtherOption["".concat(other)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Checkbox = (Checkbox);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Radio.tsx









var Radio = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _className = _element.className, className = _className === void 0 ? "" : _className, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _inline = _element.inline, inline = _inline === void 0 ? false : _inline, _label = _element.label, label = _label === void 0 ? "" : _label, _name = _element.name, name = _name === void 0 ? "" : _name, _other = _element.other, other = _other === void 0 ? false : _other, _required = _element.required, required = _required === void 0 ? false : _required, _values = _element.values, values = _values === void 0 ? [
        {
            label: "",
            selected: false,
            value: ""
        }
    ] : _values;
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        var newValues = reduxValues.map(function(el) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                selected: el.value === e.target.value
            });
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: newValues
            }
        }));
    };
    var hasOtherOption = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_OtherInput, {
            formId: formId,
            index: index,
            name: name,
            type: "radio"
        }),
        false: null
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    var handleOptionsStyle = {
        true: {
            flexDirection: "row"
        },
        false: {
            flexDirection: "column"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((forms_module_default()).form_radio, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).options,
                style: handleOptionsStyle["".concat(inline)],
                children: [
                    reduxValues.map(function(param) {
                        var _label = param.label, label = _label === void 0 ? "" : _label, _selected = param.selected, selected = _selected === void 0 ? false : _selected, _value = param.value, value = _value === void 0 ? "" : _value;
                        var handleOther = {
                            true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (forms_module_default()).option,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: name + " " + value,
                                        type: "radio",
                                        name: name,
                                        value: value,
                                        checked: selected,
                                        onChange: handleChangeValue
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: name + " " + value,
                                        children: label
                                    })
                                ]
                            }, name + " " + value),
                            false: null
                        };
                        return handleOther["".concat(label !== "other")];
                    }),
                    hasOtherOption["".concat(other)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Radio = (Radio);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/TextArea.tsx






var TextArea = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, maxlength = _element.maxlength, _rows = _element.rows, rows = _rows === void 0 ? 0 : _rows;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_text_area,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                id: name,
                name: name,
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                maxLength: maxlength,
                rows: rows,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_TextArea = (TextArea);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Select.tsx









var Select = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _className = _element.className, className = _className === void 0 ? "" : _className, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _label = _element.label, label = _label === void 0 ? "" : _label, _name = _element.name, name = _name === void 0 ? "" : _name, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _required = _element.required, required = _required === void 0 ? false : _required, _multiple = _element.multiple, multiple = _multiple === void 0 ? false : _multiple, _values = _element.values, values = _values === void 0 ? [
        {
            label: "",
            selected: false,
            value: ""
        }
    ] : _values;
    var ref;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var selectRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var handleEvent = function(e) {
            if (selectRef && selectRef.current && !selectRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleEvent);
        return function() {
            return document.removeEventListener("mousedown", handleEvent);
        };
    }, []);
    var handleChangeValue = function(e) {
        var newValues = reduxValues.map(function(el) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                selected: multiple ? el.value === e.target.id ? !el.selected : el.selected : el.value === e.target.id
            });
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: newValues
            }
        }));
        setOpen(multiple);
    };
    var handleClasses = {
        true: {
            true: "".concat((forms_module_default()).select, " ").concat(className, " ").concat((forms_module_default()).warning, " ").concat((forms_module_default()).open),
            false: "".concat((forms_module_default()).select, " ").concat(className, " ").concat((forms_module_default()).warning, " ")
        },
        false: {
            true: "".concat((forms_module_default()).select, " ").concat(className, " ").concat((forms_module_default()).open),
            false: "".concat((forms_module_default()).select, " ").concat(className, "  ")
        }
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    var handlePlaceholder = {
        true: (ref = reduxValues.find(function(el) {
            return el.selected;
        })) === null || ref === void 0 ? void 0 : ref.label,
        false: placeholder
    };
    var handleOpen = {
        true: (forms_module_default()).open,
        false: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_select,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(handleClasses["".concat(!!errors[name])]["".concat(open)]),
                ref: selectRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (forms_module_default()).select_button,
                        onClick: function() {
                            return setOpen(!open);
                        },
                        children: [
                            handlePlaceholder["".concat(!!reduxValues.find(function(el) {
                                return el.selected;
                            }))],
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CustomSelectArrow */.xl, {
                                className: handleOpen["".concat(open)]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (forms_module_default()).select_options,
                        children: reduxValues.map(function(param) {
                            var _label = param.label, label = _label === void 0 ? "" : _label, _selected = param.selected, selected = _selected === void 0 ? false : _selected, _value = param.value, value = _value === void 0 ? "" : _value;
                            var handleMultiple = {
                                true: {
                                    true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((forms_module_default()).option, " ").concat(selected ? (forms_module_default()).selected : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: value,
                                            onClick: handleChangeValue,
                                            children: label
                                        })
                                    }, value),
                                    false: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((forms_module_default()).option, " ").concat(selected ? (forms_module_default()).selected : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: value,
                                            onClick: handleChangeValue,
                                            children: label
                                        })
                                    }, value)
                                },
                                false: {
                                    true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (forms_module_default()).option,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: value,
                                            onClick: handleChangeValue,
                                            children: label
                                        })
                                    }, value),
                                    false: null
                                }
                            };
                            return handleMultiple["".concat(multiple)]["".concat(!selected)];
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Select = (Select);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/OtherInput.tsx








var OtherInput = function(param) {
    var formId = param.formId, index = param.index, name = param.name, type = param.type;
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var ref = (0,react.useState)(false), otherChecked = ref[0], setOtherChecked = ref[1];
    var ref1 = (0,react.useState)(""), otherInputValue = ref1[0], setOtherInputValue = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var hasOtherOption = reduxValues.find(function(el) {
            return el.label === "other";
        });
        if (!hasOtherOption) {
            setOtherChecked(false);
            setOtherInputValue("");
        }
    }, [
        reduxValues
    ]);
    var handleCheck = function(e) {
        setOtherChecked(e.target.checked);
        var hasOtherOption = reduxValues.find(function(el) {
            return el.label === "other";
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: hasOtherOption ? reduxValues.map(function(el) {
                    if (type === "checkbox") {
                        if (el.label === "other") {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                                selected: e.target.checked
                            });
                        }
                        return el;
                    }
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                        selected: el.label === "other"
                    });
                }) : (0,_to_consumable_array/* default */.Z)(reduxValues.map(function(el) {
                    if (type === "checkbox") {
                        return el;
                    }
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                        selected: false
                    });
                })).concat([
                    {
                        label: "other",
                        value: "",
                        selected: e.target.checked
                    }
                ])
            }
        }));
    };
    var handleChangeOtherInput = function(e) {
        setOtherInputValue(e.target.value);
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: reduxValues.map(function(el) {
                    if (el.label === "other") {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                            value: e.target.value
                        });
                    }
                    return el;
                })
            }
        }));
    };
    var handleOtherInput = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            id: "otherInput",
            type: "text",
            className: "form-control",
            value: otherInputValue,
            placeholder: "your variant",
            onChange: handleChangeOtherInput
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).option,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "".concat(name, " other"),
                type: type,
                className: (forms_module_default()).other_input,
                name: name,
                onChange: handleCheck
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "".concat(name, " other"),
                children: "Other"
            }),
            handleOtherInput["".concat(otherChecked || type === "radio")]
        ]
    });
};
/* harmony default export */ var FormAtoms_OtherInput = (OtherInput);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/index.js













;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/index.tsx






var FormBuilderComponent = function(param) {
    var _item = param.item, _formComponentInfo = _item.formComponentInfo, _data = _formComponentInfo.data, id = _data.id, code = _data.code, _form_builder_json = _data.form_builder_json, form_builder_json = _form_builder_json === void 0 ? [] : _form_builder_json, recaptchaActive = param.recaptchaActive;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,formbuilder/* addAndResetForm */.Cf)({
            id: id,
            formData: form_builder_json
        }));
        dispatch((0,formbuilder/* setFormErrors */.FB)({}));
    }, []);
    var handleElement = function(elem, index) {
        return {
            "header": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Heading, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "text": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Input, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "number": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_InputNumber, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "date": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_InputDate, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "file": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_InputFile, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "button": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Button, {
                formId: id,
                formCode: code,
                index: index,
                element: elem,
                formData: form_builder_json,
                recaptchaActive: recaptchaActive
            }, index),
            "checkbox-group": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Checkbox, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "radio-group": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Radio, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "textarea": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_TextArea, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "select": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Select, {
                formId: id,
                index: index,
                element: elem
            }, index)
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (forms_module_default()).form,
        children: form_builder_json.map(function(el, index) {
            return handleElement(el, index)[el.type];
        })
    });
};
/* harmony default export */ var builder_FormBuilderComponent = (FormBuilderComponent);

// EXTERNAL MODULE: ./components/builder/CarouselComponent/builder_carousel.module.scss
var builder_carousel_module = __webpack_require__(2314);
var builder_carousel_module_default = /*#__PURE__*/__webpack_require__.n(builder_carousel_module);
;// CONCATENATED MODULE: ./components/builder/CarouselComponent/CarouselCards/ImageBoxCard.tsx



var ImageBoxCard = function(param) {
    var card = param.card, eventListeners = param.eventListeners;
    var _image_path = card.image_path, image_path = _image_path === void 0 ? "" : _image_path, _title = card.title, title = _title === void 0 ? "" : _title, _buttonContent = card.buttonContent, buttonContent = _buttonContent === void 0 ? "" : _buttonContent, _linkValue = card.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, _targeting = card.targeting, targeting = _targeting === void 0 ? "" : _targeting;
    var contentStyle = eventListeners.contentStyle, buttonStyle = eventListeners.buttonStyle, onMouseOver = eventListeners.onMouseOver, onMouseOut = eventListeners.onMouseOut, onMouseOverButton = eventListeners.onMouseOverButton, onMouseOutButton = eventListeners.onMouseOutButton;
    var handleButton = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: (builder_carousel_module_default()).carousel_card_button,
            style: buttonStyle,
            onMouseOver: function(e) {
                return onMouseOverButton(e, "button");
            },
            onMouseOut: function(e) {
                return onMouseOutButton(e, "button");
            },
            children: buttonContent
        }),
        false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (builder_carousel_module_default()).carousel_card_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: linkValue,
            rel: "noreferrer",
            target: targeting,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (builder_carousel_module_default()).carousel_card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (builder_carousel_module_default()).carousel_card_image_wrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "carousel card image",
                            "aria-hidden": "true",
                            src: image_path
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (builder_carousel_module_default()).carousel_card_content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (builder_carousel_module_default()).carousel_card_title,
                                style: contentStyle,
                                onMouseOver: onMouseOver,
                                onMouseOut: onMouseOut,
                                children: title
                            }),
                            handleButton["".concat(!!buttonContent)]
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CarouselCards_ImageBoxCard = (ImageBoxCard);

;// CONCATENATED MODULE: ./components/builder/CarouselComponent/CarouselCards/TestimonialCard.tsx



var TestimonialCard = function(param) {
    var card = param.card, eventListeners = param.eventListeners;
    var _title = card.title, title = _title === void 0 ? "" : _title, _description = card.description, description = _description === void 0 ? "" : _description, _buttonContent = card.buttonContent, buttonContent = _buttonContent === void 0 ? "" : _buttonContent, _linkValue = card.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, _targeting = card.targeting, targeting = _targeting === void 0 ? "" : _targeting;
    var contentStyle = eventListeners.contentStyle, buttonStyle = eventListeners.buttonStyle, onMouseOver = eventListeners.onMouseOver, onMouseOut = eventListeners.onMouseOut, onMouseOverButton = eventListeners.onMouseOverButton, onMouseOutButton = eventListeners.onMouseOutButton;
    var handleButton = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: (builder_carousel_module_default()).carousel_card_button,
            style: buttonStyle,
            onMouseOver: function(e) {
                return onMouseOverButton(e, "button");
            },
            onMouseOut: function(e) {
                return onMouseOutButton(e, "button");
            },
            children: buttonContent
        }),
        false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (builder_carousel_module_default()).carousel_card_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: linkValue,
            rel: "noreferrer",
            target: targeting,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_carousel_module_default()).carousel_card,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((builder_carousel_module_default()).carousel_card_content, " ").concat((builder_carousel_module_default()).testimonials),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_carousel_module_default()).carousel_card_title,
                            style: contentStyle,
                            onMouseOver: onMouseOver,
                            onMouseOut: onMouseOut,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_carousel_module_default()).carousel_card_description,
                            style: contentStyle,
                            onMouseOver: onMouseOver,
                            onMouseOut: onMouseOut,
                            children: description
                        }),
                        handleButton["".concat(!!buttonContent)]
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var CarouselCards_TestimonialCard = (TestimonialCard);

;// CONCATENATED MODULE: ./components/builder/CarouselComponent/CarouselCards/BrandListCard.tsx



var BrandListCard = function(param) {
    var card = param.card;
    var _image_path = card.image_path, image_path = _image_path === void 0 ? "" : _image_path, _linkValue = card.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, _targeting = card.targeting, targeting = _targeting === void 0 ? "" : _targeting;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (builder_carousel_module_default()).carousel_card_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: linkValue,
            target: targeting,
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_carousel_module_default()).carousel_card,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (builder_carousel_module_default()).carousel_card_image_wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "carousel card image",
                        "aria-hidden": "true",
                        src: image_path
                    })
                })
            })
        })
    });
};
/* harmony default export */ var CarouselCards_BrandListCard = (BrandListCard);

;// CONCATENATED MODULE: ./components/builder/CarouselComponent/index.tsx









var NextArrow = function(param) {
    var onClick = param.onClick, color = param.color, backgroundColor = param.backgroundColor, type = param.type, _eventListeners = param.eventListeners, onMouseOverButton = _eventListeners.onMouseOverButton, onMouseOutButton = _eventListeners.onMouseOutButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((builder_carousel_module_default()).slick_arrow_wrapper, " ").concat((builder_carousel_module_default()).next),
        onClick: onClick,
        onMouseOver: function(e) {
            return onMouseOverButton(e, "svg");
        },
        onMouseOut: function(e) {
            return onMouseOutButton(e, "svg");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                type !== "BrandList" && /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: backgroundColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13 22L19 16L13 10",
                    stroke: color,
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        })
    });
};
var PrevArrow = function(param) {
    var onClick = param.onClick, color = param.color, backgroundColor = param.backgroundColor, type = param.type, _eventListeners = param.eventListeners, onMouseOverButton = _eventListeners.onMouseOverButton, onMouseOutButton = _eventListeners.onMouseOutButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((builder_carousel_module_default()).slick_arrow_wrapper, " ").concat((builder_carousel_module_default()).prev),
        onClick: onClick,
        onMouseOver: function(e) {
            return onMouseOverButton(e, "svg");
        },
        onMouseOut: function(e) {
            return onMouseOutButton(e, "svg");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                type !== "BrandList" && /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: backgroundColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19 22L13 16L19 10",
                    stroke: color,
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        })
    });
};
var Carousel = function(param) {
    var item = param.item;
    var _content = item.content, content = _content === void 0 ? "" : _content, _carousel = item.carousel, _cards = _carousel.cards, cards = _cards === void 0 ? [
        {}
    ] : _cards, _settings = _carousel.settings, animation = _settings.animation, contentColor = _settings.contentColor, contentHoverColor = _settings.contentHoverColor, buttonFontColor = _settings.buttonFontColor, buttonBgColor = _settings.buttonBgColor, buttonHoverFontColor = _settings.buttonHoverFontColor, buttonHoverBgColor = _settings.buttonHoverBgColor;
    var slidesToShow = content === "BrandList" ? 6 : 3;
    var slidesToShow991 = content === "BrandList" ? 4 : 2;
    var slidesToShow425 = content === "BrandList" ? 2 : 1;
    var carouselSettings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: slidesToShow991
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: slidesToShow425
                }
            }
        ]
    };
    var onMouseOver = function(e) {
        e.target.style.color = contentHoverColor;
    };
    var onMouseOut = function(e) {
        e.target.style.color = contentColor;
    };
    var onMouseOverButton = function(e, type) {
        if (type === "svg") {
            if (content === "BrandList") {
                e.target.children[0].children[0].style.stroke = buttonHoverFontColor;
            } else {
                e.target.children[0].children[0].style.fill = buttonHoverBgColor;
                e.target.children[0].children[1].style.stroke = buttonHoverFontColor;
            }
        } else {
            e.target.style.backgroundColor = buttonHoverBgColor;
            e.target.style.color = buttonHoverFontColor;
        }
    };
    var onMouseOutButton = function(e, type) {
        if (type === "svg") {
            if (content === "BrandList") {
                e.target.children[0].children[0].style.stroke = buttonFontColor;
            } else {
                e.target.children[0].children[0].style.fill = buttonBgColor;
                e.target.children[0].children[1].style.stroke = buttonFontColor;
            }
        } else {
            e.target.style.backgroundColor = buttonBgColor;
            e.target.style.color = buttonFontColor;
        }
    };
    var eventListeners = {
        contentStyle: {
            color: contentColor
        },
        buttonStyle: {
            color: buttonFontColor,
            backgroundColor: buttonBgColor
        },
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseOverButton: onMouseOverButton,
        onMouseOutButton: onMouseOutButton
    };
    var handleCarouselByType = function(card) {
        return {
            "ImageBox": /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCards_ImageBoxCard, {
                card: card,
                eventListeners: eventListeners
            }),
            "Testimonials": /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCards_TestimonialCard, {
                card: card,
                eventListeners: eventListeners
            }),
            "BrandList": /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCards_BrandListCard, {
                card: card
            })
        };
    };
    var addFakeItems = function(items) {
        var fakeItemsQty = slidesToShow - items.length;
        var fakeItemsArray = [];
        for(var i = 0; i < fakeItemsQty; i++){
            fakeItemsArray.push(i);
        }
        return fakeItemsArray.map(function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_carousel_module_default()).carousel_card_wrapper
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (builder_carousel_module_default()).carousel,
        "data-aos": animation,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carouselSettings), {
            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {
                eventListeners: eventListeners,
                color: buttonFontColor,
                backgroundColor: buttonBgColor,
                type: content
            }),
            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrow, {
                eventListeners: eventListeners,
                color: buttonFontColor,
                backgroundColor: buttonBgColor,
                type: content
            }),
            children: [
                cards.map(function(card) {
                    return handleCarouselByType(card)[content];
                }),
                addFakeItems(cards)
            ]
        }))
    });
};
/* harmony default export */ var CarouselComponent = (Carousel);

// EXTERNAL MODULE: ./components/ForCWV/Products/ProductCard.tsx
var ProductCard = __webpack_require__(4937);
// EXTERNAL MODULE: ./components/ForCWV/Products/products.module.scss
var products_module = __webpack_require__(1351);
var products_module_default = /*#__PURE__*/__webpack_require__.n(products_module);
// EXTERNAL MODULE: ./components/ForCWV/Products/BlockHeader.tsx
var BlockHeader = __webpack_require__(2119);
;// CONCATENATED MODULE: ./components/builder/ProductList/index.tsx







var Index = function(_param) {
    var tmp = _param.item, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.productListComponentInfo, ref1 = tmp1 === void 0 ? {} : tmp1, _products = ref1.products, products = _products === void 0 ? [] : _products, _block_title = ref1.block_title, block_title = _block_title === void 0 ? "" : _block_title, _showProductListCls = ref.showProductListCls, showProductListCls = _showProductListCls === void 0 ? "" : _showProductListCls, tmp2 = ref.convertedSettings, ref2 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref2.animationAos, ref3 = tmp3 === void 0 ? {} : tmp3, tmp4 = ref3["data-aos"], dataAos = tmp4 === void 0 ? "none" : tmp4, isMobile = _param.isMobile, pageProps = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "isMobile"
    ]);
    var ref4 = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), originalProducts = ref5[0], setOriginalProducts = ref5[1];
    var handleBlockTitle = {
        true: {
            true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader/* default */.Z, {
                    title: block_title
                })
            }),
            false: null
        },
        false: {
            true: null,
            false: null
        }
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref4 && ref4.current) {
                var ref;
                setOriginalProducts(window.scrollY >= ((ref = ref4.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 2);
            }
        };
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-aos": dataAos,
        children: [
            handleBlockTitle["".concat(!!products.length)]["".concat(!!block_title)],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (products_module_default())["block-products__body"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (products_module_default())["block-products__list"],
                    children: (isMobile && !originalProducts ? products.filter(function(_, indexFil) {
                        return indexFil < 4;
                    }) : products).map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                minHeight: 200
                            },
                            className: (products_module_default())["product-card-parent"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: !originalProducts ? ref4 : null,
                                className: (products_module_default())["block-products__list-item"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                    product: product,
                                    priority: index < 2
                                }, pageProps))
                            })
                        }, product.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProductList = (Index);

;// CONCATENATED MODULE: ./components/builder/RenderCustomElements.tsx















var RenderBuilderComponent = function(param) {
    var data = param.data, dbName = param.dbName, translationsData = param.translationsData, selectedLocale = param.selectedLocale, selectedCurrItems = param.selectedCurrItems, currencies = param.currencies, backOrderValue = param.backOrderValue, isMobile = param.isMobile, recaptchaActive = param.recaptchaActive;
    var VideoComponentLayout = function(param) {
        var children = param.children;
        var videoToggle = {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_module_default()).video_wrapper,
                children: children
            }),
            "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: children
            })
        };
        return videoToggle["".concat(!!(data === null || data === void 0 ? void 0 : data.fullScreen))];
    };
    var builderComponents = {
        Heading: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Heading, {
            item: data
        }),
        HyperLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_HyperLink, {
            item: data
        }),
        Editor: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Editor, {
            item: data
        }),
        Accordion: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Accordion, {
            item: data
        }),
        ImageUpload: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_ImageUpload, {
            item: data,
            dbName: dbName
        }),
        Slider: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_SliderComponent, {
            item: data
        }),
        Button: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Button, {
            item: data,
            selectedLocale: selectedLocale,
            currencies: currencies,
            backOrderValue: backOrderValue
        }),
        Video: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponentLayout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Video, {
                item: data
            })
        }),
        Posts: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_PostsComponent, {
            item: data,
            translationsData: translationsData
        }),
        FormBuilder: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_FormBuilderComponent, {
            item: data,
            recaptchaActive: recaptchaActive
        }),
        ImageBox: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselComponent, {
            item: data
        }),
        Testimonials: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselComponent, {
            item: data
        }),
        BrandList: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselComponent, {
            item: data
        }),
        ProductList: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList, {
            item: data,
            dbName: dbName,
            translationsData: translationsData,
            backOrderValue: backOrderValue,
            selectedCurrItems: selectedCurrItems,
            selectedLocale: selectedLocale,
            isMobile: isMobile
        }),
        Grid: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return builderComponents[data === null || data === void 0 ? void 0 : data.content] || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var RenderCustomElements = (RenderBuilderComponent);

;// CONCATENATED MODULE: ./components/builder/BuilderDataRender.tsx







var BuilderSection = function(_param) {
    var clientShowMap = _param.getBuilderData, tab = _param.tab, builderComponentProps = (0,_object_without_properties/* default */.Z)(_param, [
        "getBuilderData",
        "tab"
    ]);
    var ref;
    var BuilderJSX = function(param) {
        var dataKey = param.dataKey;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderCustomElements, (0,_object_spread/* default */.Z)({
            data: dataKey
        }, builderComponentProps));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block-products",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((builder_module_default())["home-product-container"], " ").concat((builder_module_default())["b-container"]),
            children: (ref = clientShowMap[tab]) === null || ref === void 0 ? void 0 : ref.map(function(param, ind) {
                var idArray = param.idArray, parentCls = param.parentCls, container = param.container, rowStyles = param.rowStyles, childWrapper = param.childWrapper, parentAlignItems = param.parentAlignItems, showOneComponent = param.showOneComponent;
                var handleComponentShow = {
                    "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderJSX, {
                        dataKey: showOneComponent
                    }),
                    "false": idArray === null || idArray === void 0 ? void 0 : idArray.map(function(param, index) {
                        var childIdArray = param.childIdArray, showOneComponentChild = param.showOneComponent, childCls = param.childCls, secondChildCls = param.secondChildCls, columnStyles = param.columnStyles;
                        var handleComponentShowChild = {
                            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderJSX, {
                                dataKey: showOneComponentChild
                            }),
                            "false": childIdArray === null || childIdArray === void 0 ? void 0 : childIdArray.map(function(elInEl, indElInEl) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (builder_module_default()).builder_component,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderJSX, {
                                        dataKey: elInEl
                                    })
                                }, indElInEl);
                            })
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(childCls, " ").concat((builder_module_default())[secondChildCls]),
                            style: columnStyles,
                            children: handleComponentShowChild["".concat(!!showOneComponentChild)]
                        }, index);
                    })
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(container, " ").concat((builder_module_default()).builder_component),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: parentCls,
                        style: rowStyles,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, childWrapper), {
                                alignItems: parentAlignItems,
                                width: "100%"
                            }),
                            children: handleComponentShow["".concat(!!showOneComponent)]
                        })
                    })
                }, ind);
            })
        })
    });
};
/* harmony default export */ var BuilderDataRender = (BuilderSection);


/***/ }),

/***/ 3519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _posts_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(406);
/* harmony import */ var _posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_posts_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);





var PostCard = function(param) {
    var _post = param.post, rightDay = _post.rightDay, image = _post.image, slug = _post.slug, name = _post.name, category = param.category, translationsData = param.translationsData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/posts/".concat(category === null || category === void 0 ? void 0 : category.slug, "/").concat(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default().postCard),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default().post_card_image),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: image,
                            alt: name,
                            layout: "fill",
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default().post_card_info),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default().post_card_name),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: name
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default().post_card_read_data),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default().post_card_date),
                                        children: rightDay
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_4___default().post_card_read_more),
                                        children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ReadMore
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCard);


/***/ }),

/***/ 2598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9498);



var ReCaptchaWrapper = function(param) {
    var children = param.children, recaptchaActive = param.recaptchaActive, recaptchaKey = param.recaptchaKey;
    if (!+recaptchaActive) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .ReCaptchaProvider */ .dR, {
        useEnterprise: true,
        reCaptchaKey: recaptchaKey,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReCaptchaWrapper);


/***/ }),

/***/ 4444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XZ": function() { return /* binding */ wishListRemoveAllItems; },
/* harmony export */   "c8": function() { return /* binding */ wishlistAddItem; },
/* harmony export */   "uv": function() { return /* binding */ wishlistRemoveItem; }
/* harmony export */ });
/* unused harmony exports wishlistAddItemSuccess, wishlistRemoveItemSuccess */
/* harmony import */ var _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6680);
// import { toast } from "react-toastify";

function wishlistAddItemSuccess(product, locale) {
    return {
        type: _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_ADD_ITEM */ .jQ,
        product: product
    };
}
function wishlistRemoveItemSuccess(productId) {
    return {
        type: _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_REMOVE_ITEM */ .vU,
        productId: productId
    };
}
function wishlistAddItem(product, locale) {
    return function(dispatch) {
        return new Promise(function(resolve) {
            setTimeout(function() {
                dispatch(wishlistAddItemSuccess(product, locale));
                resolve();
            }, 500);
        });
    };
}
function wishlistRemoveItem(productId) {
    return function(dispatch) {
        return new Promise(function(resolve) {
            setTimeout(function() {
                dispatch(wishlistRemoveItemSuccess(productId));
                resolve();
            }, 500);
        });
    };
}
function wishListRemoveAllItems() {
    return {
        type: _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_REMOVE_ALL_ITEMS */ .oe
    };
}


/***/ }),

/***/ 1351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home-product-container":"products_home-product-container__8aDSV","block-products__body":"products_block-products__body__U5Da6","block-products__list":"products_block-products__list__Kbc6J","product-card-parent":"products_product-card-parent__0QJ9h","product-card":"products_product-card__sPD03","product-card__image":"products_product-card__image__MJVv5","product-image__body":"products_product-image__body__g0hlL","item_overlay":"products_item_overlay__HhgFv","img_btn_wrapper":"products_img_btn_wrapper__IRNpd","product-card__addToCart":"products_product-card__addToCart__XdrRC","img_wrapper":"products_img_wrapper__NL0Y8","product-card__info":"products_product-card__info__oAVyS","product-card__name":"products_product-card__name__2KSSq","product-card-description":"products_product-card-description__TlHgR","product-card__actions":"products_product-card__actions__PnaLZ","product-card__availability-mobile":"products_product-card__availability-mobile__dRdC4","product-card__availability":"products_product-card__availability__kSHPn","prices":"products_prices__lxiJv","new_price":"products_new_price__9mQi7","old_price":"products_old_price__xx3OV","product-card__buttons":"products_product-card__buttons__LAq2x","product-card__wishlist":"products_product-card__wishlist__aUI5s","wishlist-circle":"products_wishlist-circle__aSQMX","wishlist-icon-wrapper":"products_wishlist-icon-wrapper__YZNXE","wishlist-circle-clicked":"products_wishlist-circle-clicked__3nScE","inner-wishlist":"products_inner-wishlist__7HpTL","hide-for-desktop":"products_hide-for-desktop__xs9Nz"};

/***/ }),

/***/ 2314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"builder_carousel_carousel__kfS6r","slick_arrow_wrapper":"builder_carousel_slick_arrow_wrapper__QGoQt","prev":"builder_carousel_prev__gHIRv","next":"builder_carousel_next__wiuMo","carousel_card_wrapper":"builder_carousel_carousel_card_wrapper___gYe0","carousel_card":"builder_carousel_carousel_card___EUyB","carousel_card_image_wrapper":"builder_carousel_carousel_card_image_wrapper___W8a9","carousel_card_content":"builder_carousel_carousel_card_content__tRfNQ","testimonials":"builder_carousel_testimonials__ynOD_","carousel_card_title":"builder_carousel_carousel_card_title__ryHxB","carousel_card_description":"builder_carousel_carousel_card_description__wAab5","carousel_card_button":"builder_carousel_carousel_card_button__DZ7fa"};

/***/ }),

/***/ 3811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"forms_form__cdi8_","heading_h1":"forms_heading_h1__kEFhx","heading_h2":"forms_heading_h2__LXpIQ","heading_h3":"forms_heading_h3__Ck0iY","heading_h4":"forms_heading_h4__VkTSN","heading_h5":"forms_heading_h5__8n1ba","heading_h6":"forms_heading_h6__7j2R2","form_input":"forms_form_input__mArPY","form_checkbox":"forms_form_checkbox__m4AB_","form_radio":"forms_form_radio___ilTL","form_input_number":"forms_form_input_number__vlKqC","form_input_date":"forms_form_input_date__RhzP9","form_text_area":"forms_form_text_area__0UQd3","form_select":"forms_form_select__HhNBx","label":"forms_label__YfM60","required":"forms_required__A6oea","description":"forms_description__4cmB3","info_text":"forms_info_text__Bt4NJ","form_button":"forms_form_button__lNCC4","options":"forms_options__i8cRo","option":"forms_option__FEDW5","other_input":"forms_other_input__pnz1E","toggle_border":"forms_toggle_border__cwXvy","toggle":"forms_toggle__Ry85V","check":"forms_check__LQd4A","checked":"forms_checked__BB8k9","select":"forms_select__BQCSF","select_button":"forms_select_button__HmsXF","select_options":"forms_select_options__QlcBT","open":"forms_open__LC4gq","selected":"forms_selected__bT2sN","warning":"forms_warning__MqJYO"};

/***/ }),

/***/ 7478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"builder_slider_slider__FGuwv","slide_wrapper":"builder_slider_slide_wrapper__TuieU","content_wrapper":"builder_slider_content_wrapper__NL6Gz","content":"builder_slider_content__yC3q1","content_title":"builder_slider_content_title__LvEqg","content_description":"builder_slider_content_description__9DUk5","content_button":"builder_slider_content_button__Qq14T"};

/***/ }),

/***/ 426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faq_component":"builder_faq_component__Y8WRi","faqs":"builder_faqs__7PGpT","faq_component_item":"builder_faq_component_item__bDrmY","faq_title_wrapper":"builder_faq_title_wrapper__q0w6I","faq_title":"builder_faq_title__Chw9Y","plus":"builder_plus__BofLx","open":"builder_open__ilXWp","faq_body":"builder_faq_body__SmCeA","block-products":"builder_block-products__sT1qo","b-container":"builder_b-container__iumtw","zg-grid-col":"builder_zg-grid-col__HDyvd","zg-row":"builder_zg-row__hLWu7","zg-dragforborder":"builder_zg-dragforborder__akYEv","builder_component":"builder_builder_component__f722A","video_wrapper":"builder_video_wrapper__0f2Ch","home-product-container":"builder_home-product-container__nmU7O","zg-col-lg":"builder_zg-col-lg__H9V0R","zg-col-md":"builder_zg-col-md__vIYqG","zg-col-sm":"builder_zg-col-sm__lV4MC"};

/***/ }),

/***/ 406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"post_page_title":"posts_post_page_title__bw1yE","post_body":"posts_post_body__mkLnC","post_filters":"posts_post_filters__Rb27a","post_category_filters":"posts_post_category_filters__xA9Ds","post_filter":"posts_post_filter__CWGZt","post_filter_title":"posts_post_filter_title__ITiHD","post_cat_filter_body":"posts_post_cat_filter_body__r2C5K","desktop":"posts_desktop__X6209","mobile":"posts_mobile__UPYBl","post_filters_row":"posts_post_filters_row__5Pnc7","active":"posts_active__kYZ_X","post_tags_filters":"posts_post_tags_filters__qbGZ_","post_tag_filter_body":"posts_post_tag_filter_body__VM_jR","post_filters_tag":"posts_post_filters_tag__0m7xz","posts_list":"posts_posts_list__sy1vj","posts_pagination":"posts_posts_pagination__k2_t3","post_list_item":"posts_post_list_item__7sCcL","postCard":"posts_postCard__6Quhc","post_card_image":"posts_post_card_image__YHBWF","post_card_info":"posts_post_card_info__ofV51","post_card_name":"posts_post_card_name__q5pZD","post_card_read_data":"posts_post_card_read_data__vMQuL","post_card_date":"posts_post_card_date__TT5hS","post_card_read_more":"posts_post_card_read_more__o5_yW","empty_post_list":"posts_empty_post_list__xT4gM","post_container":"posts_post_container__aaoWx","post-header__title":"posts_post-header__title__VENkT","post-header__meta":"posts_post-header__meta__1mKKK","post-header__meta-item":"posts_post-header__meta-item__HFbND","post__featured":"posts_post__featured__IgRDM","tags_container":"posts_tags_container__aHX1K","tag":"posts_tag__UMm_B","typography":"posts_typography___yttp","share_container":"posts_share_container__hsXlV","share_text":"posts_share_text__7buT1","share_icons":"posts_share_icons__Dag01","products-view__empty":"posts_products-view__empty__rcjQ1","products-view__empty-title":"posts_products-view__empty-title__Uekhs","products-view__empty-subtitle":"posts_products-view__empty-subtitle__HUti7","cat_select":"posts_cat_select__S_wRA","cat_button":"posts_cat_button__STg7I","drop_down_arrow":"posts_drop_down_arrow__2ViiJ","opened":"posts_opened__K2F0p","cat_drop_down":"posts_cat_drop_down__l4ZgF","cat_option":"posts_cat_option__GNxIH","selected":"posts_selected__cZr8y","category_title":"posts_category_title__aQj_R"};

/***/ })

}]);